import SvgIcon from '@Web/Src/Components/SvgIcon';
import { router } from '@inertiajs/react';

const MenuItem = ({ item, setSubMenuOpened }) => {
    const handleChangePage = (route) => {
        if (item.isExternal) {
            window.open(route, '_blank', 'noopener, noreferrer');
        } else {
            router.visit(route);
        }
        setSubMenuOpened(false);
    };

    return (
        <div
            onClick={() => handleChangePage(item.href)}
            className='hover:bg-surface-blue x_large:max-w-[320px] group w-full max-w-[300px] cursor-pointer rounded-2xl p-4'
        >
            <div className={'flex items-center justify-between'}>
                <p className={'text-black'}>{item.title}</p>
                <SvgIcon
                    onClick={() => {}}
                    collectionName={'header-icons-sprite'}
                    iconId={'arrow-link'}
                    className={
                        'text-blue ml-1 block size-6 opacity-0 group-hover:opacity-100'
                    }
                />
            </div>
            <p className='text-secondary font-normal'>{item.text}</p>
        </div>
    );
};

export default MenuItem;
